import styled from 'styled-components';

const styleBack = {
  marginLeft: '-5px',
  marginRight: '8px',
  cursor: 'pointer',
};

const ElemBack = styled.span`
  font-size: 14px;
  margin-top: -3px;
`;

export {
  ElemBack,
  styleBack
};
